import React, { useState } from "react";
import Input from '../Input';

const GlobalFilter = ({ preGlobalFilteredRows, globalFilter, setGlobalFilter, useAsyncDebounce, tableTheme}) => {
  const count = preGlobalFilteredRows.length
  const [value, setValue] = useState(globalFilter)
  const onChange = useAsyncDebounce(value => {
    setGlobalFilter(value || undefined)
  }, 200)

  return (
    <Input placeholder={`Search...`}
      value={value || ""}
      bgcolor={tableTheme.iptBgColor}
      holdercolor={tableTheme.holdercolor}
      onChange={e => {
        setValue(e.target.value);
        onChange(e.target.value);
      }}
    />
  )
};

export default GlobalFilter;